var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8.586 3A2 2 0 0 1 10 3.586L11.414 5H21a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM15 12H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }